export const TEACHER = "teacher";
export const STAFF_LEADER = "staff_leader";
export const STAFF = "staff";
export const PROGRAM_DESIGNER = "program_designer";
export const SELLER = "seller";
export const Admin = "admin";
